import type { ListLoansQuery } from '../../__generated__/graphql/api';

type ListLoansResultLoans = NonNullable<NonNullable<ListLoansQuery['listLoans']>['loans']>;

type ListLoansResultLoan = NonNullable<ListLoansResultLoans[number]>;

interface LoanListItemBorrower {
  firstName: string | null;
  lastName: string | null;
}

export interface LoanListItem {
  id: string;
  partnerAccountNumber: string | null;
  propertyState: string | null;
  status: string | null;
  creditLimit: number | null;
  aprMargin: string | null;
  isDelinquent: boolean | null;
  closedAt: string | null;
  dateOfLastActivity: string | null;
  originationDate: string | null;
  users: LoanListItemBorrower[];
  program: { name: string } | null;
}

export const toLoanListItem = (loan: ListLoansResultLoan): LoanListItem => ({
  id: loan.id ?? '',
  partnerAccountNumber: loan.partnerAccountNumber ?? null,
  propertyState: loan.propertyState ?? null,
  status: loan.status ?? null,
  creditLimit: loan.creditLimit ?? null,
  aprMargin: loan.aprMargin ?? null,
  isDelinquent: loan.isDelinquent ?? null,
  closedAt: loan.closedAt ?? null,
  dateOfLastActivity: loan.dateOfLastActivity ?? null,
  originationDate: loan.originationDate ?? null,
  users: (loan.users ?? []).map((user) => ({
    firstName: user?.firstName ?? null,
    lastName: user?.lastName ?? null,
  })),
  program: loan.program ? { name: loan.program.name } : null,
});
